import {createFileRoute} from '@tanstack/react-router';

import MedicationRequestEdit from '@/practitioner/views/medicationRequest/MedicationRequestEdit';

export const Route = createFileRoute(
  '/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit'
)({
  component: MedicationRequestEdit,
  loader: ({params}) => ({
    medicationRequestId: params.medicationRequestId
  })
});
